import { List, ListItem, Tooltip, Typography, Stack } from '@mui/material'
import { Note } from '../dashboard.types'
import { HiCIcon } from 'src/app/components/icons/icon'
import { noteIcon } from 'src/app/pages/booking/reservation-detail/header/notes/note-icon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NoteType } from 'src/api/api.generated'

export type NotesCellProps = {
  notes: Note[]
  filterNotes?: NoteType[]
}

const MAX_NOTES_LENGTH = 50

export default function NotesCell({ notes, filterNotes }: NotesCellProps) {
  if (notes.length <= 0) {
    return <></>
  }
  let filteredNotes = notes.filter((n) => n.description.length)
  if (filterNotes) {
    filteredNotes = filteredNotes.filter((n) => filterNotes.includes(n.type))
  }
  return (
    <Tooltip
      title={
        <List>
          {filteredNotes.map((n, index) => (
            <ListItem key={index}>
              <Stack direction="row" paddingY={0.25} spacing={1} alignItems={'center'}>
                <FontAwesomeIcon icon={noteIcon(n.type)} />
                <Typography sx={{ whiteSpace: 'pre-line' }}>{n.description.slice(0, MAX_NOTES_LENGTH) + (n.description.length > MAX_NOTES_LENGTH ? '...' : '')}</Typography>
              </Stack>
            </ListItem>
          ))}
        </List>
      }
    >
      <Stack rowGap={2} width="100%">
        {filteredNotes.map((n, index) => (
          <Stack direction="row" spacing={1} alignItems={'center'} key={index}>
            <HiCIcon>
              <FontAwesomeIcon icon={noteIcon(n.type)} />
            </HiCIcon>
            <Typography variant="caption" noWrap sx={{ minWidth: 0 }}>
              {n.description}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Tooltip>
  )
}
